module.exports = __webpack_public_path__ + "static/media/menu.280ff151.svg";